var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uik-trend",class:[
        `uik-trend--${_vm.type}`,
        `uik-trend--${_vm.direction}`
    ]},[_c('div',{staticClass:"uik-trend__arrow"}),(_vm.content)?_c('span',{staticClass:"uik-trend__content"},[_vm._v(_vm._s(_vm.content))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }